import { User } from '../../domain/entities/user-entity';
import { UserRepository } from '../../domain/repositories/user-repository';
import { createUser } from '../datasources/create-user';
import { editUser } from '../datasources/edit-user';
import { editUserPassword } from '../datasources/edit-user-password';
import { getUser } from '../datasources/get-user';
import { getUsers } from '../datasources/get-users';

export class UserRepositoryImpl implements UserRepository {
  async CreateUser(
    name: string,
    email: string,
    mobile_no: string,
    password: string
  ): Promise<User> {
    const result = await createUser(name, email, mobile_no, password);

    return new User(result);
  }

  async EditUser(user_id: string, name: string, email: string, mobile_no: string): Promise<User> {
    const result = await editUser(user_id, name, email, mobile_no);

    return new User(result);
  }

  async EditUserPassword(user_id: string, password: string): Promise<User> {
    const result = await editUserPassword(user_id, password);

    return new User(result);
  }

  async GetUsers(): Promise<User[]> {
    const users = await getUsers();

    return users.map((user: any) => new User(user));
  }

  async GetUser(user_id: string): Promise<User> {
    const result = await getUser(user_id);

    return new User(result);
  }
}
